import {compact} from 'underscore';

import {ProcessFlowchartNodeDetailsType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ProcessInteractiveFlowchart} from 'processes/graph-builder-processes/flowchart-viz/ProcessFlowchartVizConstants';
import {
  ProcessFlowchartDesignSpace,
  ProcessFlowchartForValidation,
  ProcessGraphBuilderRouterNode,
} from 'processes/graph-builder-processes/validation/ProcessGraphBuilderConstants';

import {getGraphBuilderNodeType} from './getGraphBuilderNodeType';

export function flowchartHasChainedRouters(
  flowchart: ProcessInteractiveFlowchart | null,
  designSpace: ProcessFlowchartDesignSpace
): boolean {
  if (flowchart == null) {
    return false;
  }
  const flowchartForValidation: ProcessFlowchartForValidation = {
    nodes: flowchart.nodes.map((node) => ({
      ...node,
      nodeType: getGraphBuilderNodeType(node, designSpace.flowchartSchema),
    })),
    edges: flowchart.edges.map((edge) => ({
      ...edge,
      toNodeId: edge.toNodeClientId,
      fromNodeId: edge.fromNodeClientId,
    })),
  };

  for (const node of flowchartForValidation.nodes) {
    if (node.type === ProcessFlowchartNodeDetailsType.ROUTER_NODE_DETAILS) {
      if (isRouterChained(node, flowchartForValidation)) {
        return true;
      }
    }
  }
  return false;
}

export function isRouterChained(
  node: ProcessGraphBuilderRouterNode,
  flowchart: ProcessFlowchartForValidation
): boolean {
  const incomingEdges = flowchart.edges.filter(({toNodeId}) => toNodeId === node.clientId);
  const parentNodes = compact(
    incomingEdges.map(({fromNodeId}) => flowchart.nodes.find(({clientId}) => clientId === fromNodeId))
  );
  const parentRouterNodes = parentNodes.filter(
    ({type}) => type === ProcessFlowchartNodeDetailsType.ROUTER_NODE_DETAILS
  );

  const outgoingEdges = flowchart.edges.filter(({fromNodeId}) => fromNodeId === node.clientId);
  const childNodes = compact(
    outgoingEdges.map(({toNodeId}) => flowchart.nodes.find(({clientId}) => clientId === toNodeId))
  );
  const childRouterNodes = childNodes.filter(
    ({type}) => type === ProcessFlowchartNodeDetailsType.ROUTER_NODE_DETAILS
  );
  return parentRouterNodes.length > 0 || childRouterNodes.length > 0;
}
